import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { ContactSupport } from "../types";
import {
	getContactSupportsAsync,
	getContactSupportDetailsAsync,
	GetContactSupportsAsyncPayload,
	GetContactSupportDetailsPayload,
	setContactSupports,
	setContactSupport,
	updateContactSupportAsync,
	UpdateContactSupportPayload,
} from "./contact_support.slice";

// Get list contact supports
function* getContactSupportsSaga(action: PayloadAction<GetContactSupportsAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<ContactSupport[]>>(
				"/dashboard/customer-requests",
				{ ...query, skip: query.skip },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setContactSupports.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetContactSupports() {
	yield takeLatest(getContactSupportsAsync, getContactSupportsSaga);
}

// Get contact support details
function* getContactSupportDetailsSaga(action: PayloadAction<GetContactSupportDetailsPayload>) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<ContactSupport>>(
				`/dashboard/customer-requests/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setContactSupport.type, payload: response });
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchContactSupportDetails() {
	yield takeLatest(getContactSupportDetailsAsync, getContactSupportDetailsSaga);
}

// Update contact support details
function* updateContactSupportSaga(action: PayloadAction<UpdateContactSupportPayload>) {
	const { id, status, note, caringStaffId, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.put(
				`/dashboard/customer-requests/${id}`,
				{
					status,
					note,
					caringStaffId
				}
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: getContactSupportDetailsAsync.type, payload: response });
		message.success(translate("Update successful"));
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateContactSupport() {
	yield takeLatest(updateContactSupportAsync, updateContactSupportSaga);
}

const contactSupportSaga = [
	watchGetContactSupports(),
	watchContactSupportDetails(),
	watchUpdateContactSupport(),
];
export default contactSupportSaga;
